import { useEffect, useState } from 'react';
import styles from './index.less'
import classNames from 'classnames';
import QRCodeLogin from './components/QRCodeLogin';
import TelLogin from './components/TelLogin';
import closeSvg from '@/assets/icon/close.svg'
import * as API from './api'
import Button from '../Button';
import { getUserInfo } from '@/utils/getUserInfo'
import { getCookie } from '@/utils/cookie'
import { setIsLogin, useStore } from '@/states/store'
import { openPopDialog } from '@/components/RewordPop'
import RprmUtils from "@/utils/dot";
import { wsStore } from '@/states/ws'
import { useSnapshot } from 'umi'
import { message } from 'antd';
import * as Sentry from '@sentry/react'
import { history } from 'umi';
import LoginHoldPopupShow from '@/components/LoginHoldPopup/show';
import { openLoginHoldPopup } from '@/components/LoginHoldPopup/open';

interface IProps {
  open?: boolean;
  onClose?: Function;
  onLogin?: Function;
}

export default ({ open, onClose, onLogin }: IProps) => {

  const [isShow, setIsShow] = useState(false)

  const [loginType, setLoginType] = useState<'QRCode' | 'Tel'>('QRCode')

  const [regionCodeList, setRegionCodeList] = useState<IRegion[]>([])
  const [isBind, SetIsBind] = useState(false)
  const [isCaptchaMode, setIsCaptchaMode] = useState(false);

  const [ticket, setTicket] = useState('');
  const { userInfo } = useStore()

  useEffect(() => {
    API.getZoneList().then(res => {
      setRegionCodeList(res.data || [])
    })
  }, [])

  useEffect(() => {
    if (open) {
      if (getCookie('token')&&userInfo?.channelType!== 2) {
        history.push({ pathname: '/' })
        location.reload()
      } else {
        setIsShow(true)
        setLoginType('QRCode')
        setTicket('')
        setIsCaptchaMode(false)
        SetIsBind(false)
      }
      return
    }
    const loginDialog = document.getElementById('loginDialog')
    loginDialog?.classList.remove(styles.openDialog)
    loginDialog?.getBoundingClientRect()
    loginDialog?.classList.add(styles.closeDialog)
    setTimeout(() => {
      setIsShow(false)
      // onClose?.()
    }, 300)
  }, [open])

  useEffect(() => {
    if(isShow){
        RprmUtils.rec(`show_login_dialog`, 'view', { en: 'tap', et: 'custom' })
    }
  }, [isShow])

  const toggleLoginType = () => {
    setLoginType(prev => prev === 'QRCode' ? 'Tel' : 'QRCode')
  }

  const closeDialog = () => {
    if (getCookie('token')) {
      if(userInfo?.channelType !== 2){
        message.success('登录成功');
      }
    }
    onClose?.()
  }

  const bindTel = ({ ticket }: { ticket: string }) => {
    setTicket(ticket)
    SetIsBind(true)
  }

  const login = async () => {
    await getUserInfo()
    if (getCookie('token')) {
      RprmUtils.initializePublicParams()
      setIsLogin(true)
    } else {
      setIsLogin(false)
    }
    onLogin && onLogin()
    closeDialog()

  }

  const clickClose = () => {
    const show = LoginHoldPopupShow.show();
    if (!show) {
        return closeDialog();
    }
    openLoginHoldPopup({onClose: closeDialog});
  }

  const goToRoute = (type: string) => {
    window.open(`/protocol?type=` + type)
  }

  return isShow ? <div id="loginDialog" className={classNames(styles.mask, styles.openDialog)}>

    {/* layout */}
    <div className={styles.container}>
      <div className={styles.imageWrapper}>
      </div>

      <div className={styles.loginWrapper}>
        <div className={styles.loginBox}>

          <div className={styles.loginType}>
            {!isBind && !isCaptchaMode && <>
              <div className={styles.btn} onClick={toggleLoginType}>
                {loginType === 'QRCode' && '验证码登录'}
                {loginType === 'Tel' && '微信登录'}
              </div>
              {loginType === 'QRCode' && <img onClick={toggleLoginType} src="https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/qiehuandaoshoujiyanzhengma.png" />}
              {loginType === 'Tel' && <img onClick={toggleLoginType} src="https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/qiehuandaoweixindenglu.png" />}
            </>
            }

          </div>

          {
            !isBind && loginType === 'QRCode'
              ? <QRCodeLogin bindTel={bindTel} closeDialog={closeDialog} onLogin={login} />
              : <TelLogin
                closeDialog={closeDialog}
                setIsCaptchaMode={setIsCaptchaMode}
                isCaptchaMode={isCaptchaMode}
                isBind={isBind}
                regionCodeList={regionCodeList}
                onLogin={login}
                ticket={ticket}
              />
          }

          {!isBind && <p className={styles.agreement}>登录即表示同意 <Button type="link" onClick={() => goToRoute('service')}>《WIME服务协议》</Button><Button onClick={() => goToRoute('info')} type="link">《WIME个人信息处理规则》</Button></p>}
        </div>

      </div>

      {/* close */}
      <div className={styles.close} onClick={clickClose}>
        <img src={closeSvg} />
      </div>

    </div>


  </div> : null
}





